/**
 * @format
 */
import 'regenerator-runtime/runtime';
import 'react-native-gesture-handler';
import {AppRegistry} from 'react-native';
import App from './App';
import {registerRootComponent} from 'expo';

// Register the main component
AppRegistry.registerComponent('main', () => App);
registerRootComponent(App);